import {Alert} from "@mui/material";
import SignButtons from "./SignButtons";

function AlertSignButtons({alert = ''}) {
    return <Alert severity={'info'} variant={'outlined'} action={<SignButtons />}>{alert}</Alert>
}

export default AlertSignButtons;